import { render, staticRenderFns } from "./clamp.vue?vue&type=template&id=c8ffe726&scoped=true&"
import script from "./clamp.vue?vue&type=script&lang=js&"
export * from "./clamp.vue?vue&type=script&lang=js&"
import style0 from "./clamp.vue?vue&type=style&index=0&id=c8ffe726&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ffe726",
  null
  
)

export default component.exports